import { useTheme } from "@/theme/ThemeProvider";
import React from "react";
import { View, ViewStyle } from "react-native";

type Props = {
  variant?: "default" | "dashed";
  children: React.ReactNode;
  style?: ViewStyle;
};

export function Card({ variant = "default", children, style }: Props) {
  const { theme } = useTheme();

  return (
    <View
      style={[
        {
          backgroundColor: theme.color.surface,
          borderRadius: theme.radius.lg,
          padding: theme.space.md,
          borderWidth: 1,
          borderColor: variant === "dashed"
            ? theme.color.primaryMuted
            : theme.color.border,
          borderStyle: variant === "dashed" ? "dashed" : "solid",
        },
        style,
      ]}
    >
      {children}
    </View>
  );
}
